export default {
  pageInfo: {
    url: 'website/operator/pageInfo',
  },
  rangeInit: {
    url: 'website/operator/rangeInit',
    method: 'get',
  },
  rangeSubmit: {
    url: 'website/operator/rangeSubmit',
  },
  roleQueryInit: {
    url: 'website/role/queryInit',
    method: 'get',
  },
  queryPermission: {
    url: 'website/role/queryPermissions',
    method: 'get',
  },
  updateSubmit: {
    url: 'website/role/updateSubmit',
  },
  validateInfo: {
    url: 'website/operator/validateInfo',
  },
  dataSubmit: {
    url: 'website/operator/dataSubmit',
  },
  updateInfo: {
    url: 'website/operator/updateInfo',
  },
  resetPassword: {
    url: 'website/operator/resetPassword',
  },
  addInit: {
    url: 'website/role/addInit',
    method: 'get',
  },
  addSubmit: {
    url: 'website/role/addSubmit',
  },
  deleteSubmit: {
    url: '/website/role/deleteSubmit',
    method: 'get',
  },
  dataInit: {
    url: '/website/operator/dataInit',
    method: 'get',
  },
  deleteInfo: {
    url: '/website/operator/deleteInfo',
  },
  updateStatus: {
    url: 'website/operator/updateStatus',
  },
};



// WEBPACK FOOTER //
// ./src/service/apiConfig/apiManageOperator.js